// extracted by mini-css-extract-plugin
export default {"Text":"Text_Text__wnkyL"};